import { render } from "./Stars.vue?vue&type=template&id=4b00634c&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=ts"
export * from "./Stars.vue?vue&type=script&lang=ts"

import "./Stars.vue?vue&type=style&index=0&id=4b00634c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b00634c"

export default script